import './ProviderForm.css';

import type { FormInstance }   from 'antd';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { Col }                 from 'antd';
import { Form }                from 'antd';
import { Input }               from 'antd';
import { Upload }              from 'antd';
import { Button }              from 'antd';
import { UploadOutlined }      from '@ant-design/icons';
import Row                     from 'components/App/Row';
import ProviderLogoMediaModel  from 'models/ProviderLogoMediaModel';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import type { RefObject }      from 'react';
import ProviderModel           from 'models/ProviderModel';
import handleFormError         from 'utils/handleFormError';
import { messageErrorIntl }    from 'utils/messageIntl';
import { messageSuccessIntl }  from 'utils/messageIntl';
import { AppFormComponent }    from 'components/App/AppForm';

interface ProviderFormProps {
  model: ProviderModel;
}

@observer
class ProviderForm extends AppFormComponent<ProviderFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

  public state = {
    logoList: [] as any[],
  };

  public componentDidMount() {
    this.initLogoList();
  }

  public componentDidUpdate(prevProps: ProviderFormProps) {
    if (prevProps.model.id !== this.props.model.id) {
      this.initLogoList();
      this.formRef.current?.resetFields();
    }
  }

  public render() {
    const { model } = this.props;

    return (
      <Form
        className="modal-form antd-form-custom-style"
        initialValues={{
          email: model.get('email'),
          link: model.get('link'),
          logo: model.get('logo.@id'),
          name: model.get('name'),
        }}
        ref={this.formRef}
      >
        <Row>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Nom" />}
              labelCol={{ span: 24 }}
              name="name"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Nom manquant" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Email" />}
              labelCol={{ span: 24 }}
              name="email"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Email manquant" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Lien" />}
              labelCol={{ span: 24 }}
              name="link"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Lien manquant" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Logo (75 px X 75 px, taille max. 5 Mo)" />}
              labelCol={{ span: 24 }}
              name="logo"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Logo manquant" />,
                  required: true,
                },
              ]}
            >
              <Upload
                beforeUpload={file => {
                  this.beforeUpload(file);
                  return false;
                }}
                defaultFileList={this.state.logoList}
                fileList={this.state.logoList}
                onRemove={() => this.onRemove()}
              >
                <Button
                  htmlType="button"
                  icon={<UploadOutlined />}
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <FormattedMessageWrapper id="Ajouter un fichier" />
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { model } = this.props;

    try {
      const values = await this.formRef.current?.validateFields();
      await model.patch(values);
      messageSuccessIntl("Prestataire enregistré !");
      this.formRef.current?.resetFields();
      this.setState({ logoList: [] });
      this.props.onSuccess?.();
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };

  private beforeUpload = (file: any) => {
    this.setState({ logoList: [file] });

    const providerLogoMediaModel = new ProviderLogoMediaModel();
    providerLogoMediaModel.set('file', file);
    providerLogoMediaModel.save().then(
      (providerLogoMedia: ProviderLogoMediaModel) => {
        this.formRef.current?.setFieldsValue({
          logo: providerLogoMedia.data['@id'],
        });
      },
      () => {
        messageErrorIntl("Le chargement du fichier a échoué.");
        this.setState({ logoList: [] });
      },
    );
  };

  private initLogoList = () => {
    const { model } = this.props;

    this.setState({
      logoList: model.get('logo')
        ? [{ name: model.get('logo.mediaFileName'), uid: model.get('logo.@id') }]
        : [],
    });
  };

  private onRemove = () => {
    this.formRef.current?.resetFields(['logo']);
    this.setState({ logoList: [] });
  };
}

export default ProviderForm;
